import React from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles, Button } from "@material-ui/core";
import { useSnackbar } from "notistack";
import { useHistory, useLocation } from "react-router-dom";

import { hasItems } from "util/APIUtils";
import {
  selectOrder,
  selectCartError,
  selectCartIsLoading,
} from "selectors/cart";
import LoadingIndicator from "components/LoadingIndicator";
import { getCart as getCartAction, checkoutCart } from "modules/cart";
import Invoice from "./components/Invoice";

const useStyles = makeStyles(() => ({
  root: {
    maxWidth: 500,
    margin: "auto",
    textAlign: "left",
    paddingTop: "30px",
  },
  buttons: {
    textAlign: "center",
    padding: "1em 0",
  },
}));

const Checkout = ({ initiatingBrand, children: buttons }) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  let order = location?.state?.order || null;
  const storeOrder = useSelector(selectOrder);
  const error = useSelector(selectCartError);
  const loading = useSelector(selectCartIsLoading);
  const getCart = (...args) => dispatch(getCartAction(...args));
  const { enqueueSnackbar } = useSnackbar();

  if (!order) {
    order = storeOrder;
  }

  const classes = useStyles();
  const noOrder = hasItems(order);
  const paid = order && order.receiptPresented;
  const nextStepLabel = paid ? "Show me my Brands" : "Proceed to checkout";

  const continueToNextStep = () => {
    if (paid) {
      history.push("/my-brands");
    } else {
      dispatch(checkoutCart(history.location));
    }
  };

  if (loading) return <LoadingIndicator />;

  return (
    <div className={classes.root}>
      {!!error && <div className="error">{error}</div>}
      <Invoice
        paid={order.receiptPresented}
        initiatingBrand={initiatingBrand}
        order={order}
        updateInvoice={getCart}
        enqueueSnackbar={enqueueSnackbar}
      />
      {buttons || (
        <div className={classes.buttons}>
          <Button
            variant="contained"
            color="primary"
            disabled={noOrder}
            onClick={continueToNextStep}
          >
            {nextStepLabel}
          </Button>
        </div>
      )}
    </div>
  );
};

Checkout.propTypes = {
  children: PropTypes.object,
  location: PropTypes.object.isRequired,
};

export default Checkout;
